// Lucide icon: arrow-left-to-line (https://lucide.dev/icons/arrow-left-to-line)
import { ArrowLeftToLine } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconMoveLeft = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ArrowLeftToLine />
    </IconComponentStyled>
  )
}
